import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useBuildTemplateDetailsViewModel = ({ buildTemplateId }) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [buildTemplate, setBuildTemplate] = useState({});

  const getBuildTemplate = () => {
    stateManager.run(async () => {
      const response = await taskService.buildTemplate.get({
        id: buildTemplateId,
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setBuildTemplate(response.data);
      }
    });
  };

  return {
    isLoading,
    buildTemplate,
    getBuildTemplate,
  };
};
